"use client";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-8">
      <div className="border-2 border-border-thick rounded-xl shadow-brutal bg-white p-8 max-w-md text-center">
        <div className="font-display text-4xl mb-4">Something went wrong</div>
        <p className="font-body text-border-thick/50 mb-6">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={reset}
          className="inline-block bg-primary text-white font-display font-semibold px-6 py-3 rounded-lg border-2 border-border-thick shadow-brutal-sm active:translate-x-[2px] active:translate-y-[2px] active:shadow-none transition-all cursor-pointer"
        >
          Try Again
        </button>
      </div>
    </main>
  );
}
